/* eslint-disable max-len */
import api from 'api/api';
import downloadReceipt from 'utils/downloadReceipt';
import {
  IFormValues,
  IMobileMoneyChargeResponse,
  INetwork,
  IWalletBenResponse,
  IWalletState,
} from './MobileMoneyTransfer.model';

export interface IWalletTransferBody {
  accountNumber: string;
  phoneNumber: string;
  uniqueTransType: 'A2W';
  networkCode: string;
  amount: number;
  narration: string;
  passwordType: string;
  password: string;
  currencyCode: string;
  accountName: string;
  saveBen: boolean;
  eLevyId: string;
  eLevyCharge: number;
  transType: string;
  charge: number;
  networkGipCode: string | INetwork | undefined;
}

let network: IWalletState['networks'];

export const lookupBen = (networkCode: string, phoneNumber: string, transferType: 'A2W') =>
  api
    .get<IWalletBenResponse>(
      `transfer/mobilemoneylookup?network=${networkCode}&phoneNumber=${phoneNumber}&transferType=${transferType}`,
    )
    .then((data) => ({ accountName: data.accountName }));

export const getReceipt = (transactionID: number) =>
  api.get(`/transaction/receipt?trnxID=${transactionID}`).then(downloadReceipt);

export const getTransactionFee = (amount: number, phoneNumber: string) =>
  api.get<IMobileMoneyChargeResponse>(
    `transfer/momocharge?amount=${amount}&phoneNumber=${phoneNumber}`,
    {},
    false,
    false,
  );

export const ON_SUBMIT = () => [
  (values: IFormValues, otp: string, saveBen: boolean, eLevyId: string, charge: number, benName: string) => {
    const { sourceAccount, phoneNumber, networkCode, ...restA2WBody } = values;
    const gipCodeForResponse = network ? network.find((networks) => values?.networkCode === networks.gipCode) : '';
    const body: IWalletTransferBody = {
      ...restA2WBody,
      accountNumber: sourceAccount,
      passwordType: 'OTP',
      password: otp,
      accountName: benName,
      saveBen,
      currencyCode: 'GHS',
      uniqueTransType: 'A2W',
      networkCode,
      phoneNumber,
      eLevyId,
      charge,
      transType: 'MOBILEMONEY-TRANSFER',
      networkGipCode: gipCodeForResponse,
    };
    return api.post('transfer/mobilemoney', body);
  },
];
